import { PaymentType } from '@/types'
import { useI18n } from 'vue-i18n'

/**
 * Returns a composable object with a functions to generate support texts depending on PaymentType.
 *
 * @returns An object with the `addValueTextMobile` functions.
 */
export const useSupportText = () => {
  const { t } = useI18n()

  /**
   * Generates value support text based on the provided payment type.
   *
   * @param value - The payment type.
   * @returns The value support text.
   */
  function addValueTextByType(value: PaymentType): string {
    switch (value) {
      case PaymentType.purchase:
        return t('form.label.addValue.purchase')
      case PaymentType.instalments:
        return t('form.label.addValue.installment')
      case PaymentType.fundraising:
        return t('form.label.addValue.fundraising')
      case PaymentType.fundraisingDonate:
        return t('form.label.addValue.fundraisingDonate')
      default:
        return t('form.label.add')
    }
  }

  /**
   * Generates info support text based on the provided payment type.
   *
   * @param value - The payment type.
   * @returns The info support text.
   */
  function supportInfoTextByType(value: PaymentType): string {
    switch (value) {
      case PaymentType.purchase:
        return t('form.label.supportInfo.purchase')
      case PaymentType.instalments:
        return t('form.label.supportInfo.installment')
      case PaymentType.fundraising:
        return t('form.label.supportInfo.fundraising')
      case PaymentType.fundraisingDonate:
        return t('form.label.supportInfo.fundraisingDonate')
      default:
        return ''
    }
  }
  return {
    addValueTextByType,
    supportInfoTextByType
  }
}
